import { redirectWithSsoHandoff } from './ssoHandoff';

/** TinyWins parent app (shared Cognito SSO landing for parents). */
export const TINYWINS_MAIN_APP_URL_DEFAULT = 'https://www.tinywins.ai';

/** MiraPlus therapist app (shared Cognito; separate AppSync). */
export const MIRAPLUS_APP_URL_DEFAULT = 'https://www.miraplus.ai';

export function getTinyWinsMainAppUrl(): string {
  const raw =
    import.meta.env.VITE_MAIN_APP_URL?.trim() ||
    import.meta.env.VITE_TINYWINS_APP_URL?.trim() ||
    TINYWINS_MAIN_APP_URL_DEFAULT;
  return raw.replace(/\/+$/, '');
}

export function getMiraPlusAppUrl(): string {
  const raw = import.meta.env.VITE_MIRAPLUS_APP_URL?.trim() || MIRAPLUS_APP_URL_DEFAULT;
  return raw.replace(/\/+$/, '');
}

/** True when the current browser host is a MiraPlus deployment. */
export function isMiraPlusHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  if (host.includes('miraplus')) return true;
  if (host.includes('d3thlailncjl57')) return true;
  return import.meta.env.VITE_APP_SURFACE?.trim().toLowerCase() === 'miraplus';
}

/** Parents authenticating on MiraPlus must continue on TinyWins. */
export function shouldRedirectParentToTinyWins(role: string | null | undefined): boolean {
  return isMiraPlusHost() && String(role || '').toUpperCase() === 'PARENT';
}

export async function redirectParentToTinyWinsWithSso(path = '/'): Promise<void> {
  await redirectWithSsoHandoff(getTinyWinsMainAppUrl(), path);
}

/**
 * Optional: send therapists from TinyWins → MiraPlus when explicitly enabled.
 * Off by default so TinyWins therapist flows are not disrupted.
 */
export function shouldRedirectTherapistToMiraPlus(role: string | null | undefined): boolean {
  if (!import.meta.env.VITE_REDIRECT_THERAPISTS_TO_MIRAPLUS) return false;
  if (isMiraPlusHost()) return false;
  const r = String(role || '').toUpperCase();
  return r === 'THERAPIST' || r === 'ORG_ADMIN' || r === 'CLINICIAN';
}

export async function redirectTherapistToMiraPlusWithSso(path = '/'): Promise<void> {
  await redirectWithSsoHandoff(getMiraPlusAppUrl(), path);
}
